import { useTranslation, Trans } from "react-i18next";

import CountUp from 'react-countup';

import main from '../../img/main-a.png';
import main2 from '../../img/main2-a.png'


function Main () {

    const { t } = useTranslation();
      
    return(
        <>
            <div className="overflow-hidden relative xl:h-[770px] max-w-[1220px] mx-[20px] xl:mx-auto bg-[#2A323F] mt-[60px] xl:mt-0">
                <div className="flex flex-col md:flex-row gap-[0px] sm:gap-[40px] xl:gap-0 justify-between xl:px-[40px]">
                    <div className="pt-[30px] xl:pt-[140px] relative z-20 px-[20px] xl:px-0 w-full flex flex-col items-start">
                        <p className="host-grotesk text-[32px] xl:text-[48px] leading-[1.2] font-[300] text-[#E9E4DA]"><Trans i18nKey="about.1" components={{ span: <span className="text-[#FC2E00]" /> }} /></p>
                        <p className="leading-[1.2] text-[#E9E4DA] text-[30px] md:text-[36px] max-w-[526px] xl:text-[64px] font-[600] host-grotesk">{t('home.1')}</p>
                        <div className="bg-[#FFFFFF] h-px w-[560px] z-0 mt-[20px] xl:mt-[40px]"></div>
                        <p className="mt-[40px] xl:max-w-[530px] PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2]"><Trans>{t('about.2')}</Trans></p>
                        <p className="mt-[20px] xl:max-w-[530px] PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2]"><Trans>{t('about.3')}</Trans></p>
                    </div>
                    <img src={main} className="hidden xl:block absolute right-0" alt="" />
                    <img src={main2} className="xl:hidden block pt-[80px] md:pt-0" alt="" />
                </div>
            </div>
        </>
    );
}

export default Main;